import { render, staticRenderFns } from "./homeB.vue?vue&type=template&id=a3f27d92&scoped=true&"
import script from "./homeB.vue?vue&type=script&lang=js&"
export * from "./homeB.vue?vue&type=script&lang=js&"
import style0 from "./homeB.vue?vue&type=style&index=0&id=a3f27d92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f27d92",
  null
  
)

export default component.exports